import React from "react"
import { FormattedMessage } from "react-intl"
import { Box, Link, Typography } from "@carrotfertility/carotene-core"

export default function CarrotPlanIsOnTheWayBanner(): JSX.Element {
  const getMessage = () => {
    return (
      <FormattedMessage defaultMessage="We are matching you with a Carrot Companion who will be creating your Carrot Plan. We will send you an email when it is ready within one business day." />
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="row-reverse"
      padding={(theme) => theme.spacing(theme.tokens.spacing.lg)}
      gap={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      border={(theme) => `1px solid ${theme.palette.primary.accent}`}
      borderRadius={(theme) => theme.tokens.borderRadius.sm}
    >
      <Box display="flex" flexDirection="column">
        <Box>
          <Typography
            variant="h4"
            color={(theme) => theme.palette.text.primary}
            marginBottom={(theme) => theme.tokens.spacing.xs}
          >
            <FormattedMessage defaultMessage="Your Carrot Plan is on the way" />
          </Typography>
          <Typography
            variant="body1"
            color={(theme) => theme.palette.text.primary}
            paddingBottom={(theme) => theme.tokens.spacing.lg}
          >
            {getMessage()}
          </Typography>
          <Typography variant="body1" color={(theme) => theme.palette.text.primary}>
            <FormattedMessage
              defaultMessage="In the meantime, explore your benefit highlights or see more detailed information in your <link>benefit guide</link>. "
              values={{
                link: (linkContent) => (
                  <Link href={"/your-benefit-guide"} fontSize="inherit" color="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
